import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

const styles = () => ({
    root: {
        fontSize: '0.8em',
        color: '#ccc'
    },
    text: {
        fontSize: '0.8em',
        color: '#aaa'
    },
    footerLink: {
        color: '#aaa'
    },
    footer: {
        marginBottom: '20px'
    }
});

const Footer = ({ classes }) => (
    <div className={classes.footer}>
        <Typography
            className={classes.text}
            variant="body1"
            align="center"
            gutterBottom
        >
            © {new Date().getFullYear()}{' '}
            <a href="https://shuttleid.uk" className={classes.footerLink}>
                ShuttleID
            </a>{' '}
            |{' '}
            <a
                href="https://shuttleid.uk/static/shuttleid-terms-of-use-passengers,-purchasers-and-other-users-updated-august-2020-8c80ca7b2c819e755e149871e5a98e88.pdf"
                // eslint-disable-next-line react/jsx-no-target-blank
                target="_blank"
                className={classes.footerLink}
            >
                Terms
            </a>{' '}
            |{' '}
            <a
                href="https://shuttleid.uk/static/shuttleid-privacy-policy-updated-august-2020-1f3876453c560ea7925d409ffce653e0.pdf"
                // eslint-disable-next-line react/jsx-no-target-blank
                target="_blank"
                className={classes.footerLink}
            >
                Privacy policy
            </a>{' '}
            | Build 1706
        </Typography>
        <Typography
            className={classes.text}
            variant="body1"
            align="center"
            gutterBottom
        >
            Cevenco Ltd trading as ShuttleID is a limited company registered in
            England and Wales. Registered number: 11901852.
        </Typography>
    </div>
);

Footer.propTypes = {
    classes: PropTypes.shape().isRequired
};

export default withStyles(styles)(Footer);
